import {Checkbox} from "@kaltura/ds-react-components";
import {StyledContainer, StyledTypography, StyledTimeInput} from "./StyledComponents";
import {translate} from "@mediaspace/shared/utils";
import {useState, useEffect} from "react";
import {parseTime, stringifyTime} from "../helper";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";
import {useButtonAnalytics} from "@mediaspace/hooks";

interface TimeSectionProps {
    onTimeUpdate: (startTime: number) => void;
    embedMethod?: "embed" | "oembed";
}

/**
 * start time section - sets start time param for embed code
 */
const TimeSection = (props: TimeSectionProps) => {

    const {onTimeUpdate, embedMethod} = props

    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [displayStartTime, setDisplayStartTime] = useState<string>(stringifyTime(0));

    const sendButtonAnalytics = useButtonAnalytics();

    const toggleCheckbox = () => {
        setIsChecked(previous => !previous);
        // send analytics
        const action = !embedMethod ? "Media Share" : (embedMethod === "embed" ? "Embed" : "oEmbed");
        sendButtonAnalytics(`${action} - Start time box`, ButtonClickAnalyticsType.TOGGLE);
    }

    const updateStartTime = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDisplayStartTime(e.target.value);
    }

    useEffect(() => {
        const startTime = isChecked ? parseTime(displayStartTime) : 0;
        onTimeUpdate(startTime);
    }, [isChecked, displayStartTime])

    return (
        <StyledContainer className="kms-ds-media-page-share-modal-time-section">
            <Checkbox
                onChange={toggleCheckbox}
                checked={isChecked}
            />
            <StyledTypography variant={'body2Highlight'}>
                {translate("Start video at")}
            </StyledTypography>
            <StyledTimeInput
                value={displayStartTime}
                onChange={updateStartTime}
                disabled={!isChecked}
            />
        </StyledContainer>
    )
}

export default TimeSection;
